document.addEventListener("DOMContentLoaded", function () {
  function updateButtonText() {
    const buttons = document.querySelectorAll(".btn");
    if (window.innerWidth < 768) {
      buttons.forEach(function (btn) {
        if (btn.textContent.trim().toLowerCase() === "see how boot leggings work") {
          btn.textContent = "Learn More";
        }
      });
    } else {
      // Optional: revert back to original text when above 768px
      buttons.forEach(function (btn) {
        if (btn.textContent.trim().toLowerCase() === "learn more") {
          btn.textContent = "See How Boot Leggings Work";
        }
      });
    }
  }

  // Run on page load
  updateButtonText();

  // Run on window resize
  window.addEventListener("resize", updateButtonText);
});

// Function to add alt text to images without one
function addAltText(img) {
  if (!img.hasAttribute('alt') || img.getAttribute('alt').trim() === '') {
    const src = img.getAttribute('src');
    if (src) {
      const fileName = src.split('/').pop().split('.')[0];
      const altText = fileName.replace(/[-_]/g, ' ').trim();
      img.setAttribute('alt', altText || 'image');
    } else {
      img.setAttribute('alt', 'image');
    }
  }
}

// Run on all existing images
document.querySelectorAll('img').forEach(addAltText);

// Observe for new images added dynamically
const observer = new MutationObserver(mutations => {
  mutations.forEach(mutation => {
    mutation.addedNodes.forEach(node => {
      // If a new <img> is directly added
      if (node.tagName === 'IMG') {
        addAltText(node);
      }
      // If new elements contain <img> tags inside
      else if (node.querySelectorAll) {
        node.querySelectorAll('img').forEach(addAltText);
      }
    });
  });
});

// Start observing the whole document
observer.observe(document.body, { childList: true, subtree: true });



document.addEventListener('DOMContentLoaded', function () {
  // Find all blog sidebar sections (in case there are multiple)
  document.querySelectorAll('.blog-archive__sidebar').forEach(function (sidebar) {
    const title = sidebar.querySelector('.blog-archive__tags-title');
    const tagsList = sidebar.querySelector('.blog-tags');

    if (title && tagsList) {
      title.addEventListener('click', function () {
        // Only run on mobile
        if (window.innerWidth <= 768) {
          tagsList.classList.toggle('active');
          title.classList.toggle('open');
        }
      });
    }
  });
});


document.addEventListener("DOMContentLoaded", function () {
  const trigger = document.querySelector(".tpe-trigger");
  const popup = document.getElementById("tpe-popup");
  const closeBtn = document.querySelector(".tpe-close");

  if (!trigger || !popup || !closeBtn) return;

  // Open popup
  trigger.addEventListener("click", function () {
    popup.style.display = "flex";
  });

  // Close popup with X
  closeBtn.addEventListener("click", function () {
    popup.style.display = "none";
  });

  // Close popup by clicking outside box
  popup.addEventListener("click", function (e) {
    if (e.target === popup) {
      popup.style.display = "none";
    }
  });
});


